export const paymentTicketsInfoStyle = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '40px',
    maxWidth: '495px',
    width: '100%',
    margin: '0 auto',
    marginBottom: '40px',
  },

  headerWrapper: {
    display: 'flex',
    gap: '16px',
    flexDirection: 'column',
    marginBottom: '24px',
  },

  header: {
    '& .MuiTypography-root': {
      fontSize: '12px',
      color: 'var(--neutral-300)',

      '&:not(:first-child)': {
        textAlign: 'end',
      },
    },
    display: 'flex',
    justifyContent: 'space-between',
    gap: '24px',

    '& > :nth-of-type(1)': {
      maxWidth: '200px',
      width: '100%',
    },
    '& > :nth-of-type(2)': {
      maxWidth: '100px',
      width: '100%',
    },
    '& > :nth-of-type(3)': {
      maxWidth: '100px',
      width: '100%',
    },
  },

  content: {
    background: 'var(--neutral-50)',
    height: '100%',
    padding: '24px',
    borderRadius: 'var(--default--border-radius)',
  },

  title: {
    textAlign: 'center',
    marginBottom: '24px',
  },

  contentItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    textAlign: 'end',

    '& .col-name': {
      maxWidth: '200px',
      width: '100%',
      textAlign: 'start',
    },
    '& .col-amount': {
      maxWidth: '100px',
      width: '100%',
    },
    '& .col-total': {
      maxWidth: '100px',
      width: '100%',
      fontWeight: 700,
    },
  },

  coverFeeTitle: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',

    '& .MuiCheckbox-root': {
      marginRight: '3px',
    },
  },

  coverFee: {
    display: 'flex',
    justifyContent: 'space-between',
  },

  coverFeeTooltip: {
    display: 'flex',

    '& svg': {
      width: '16px',
      height: '16px',
      '& path': {fill: 'var(--neutral-400)'},
    },
  },

  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    '& .MuiTypography-root': {
      color: 'var(--primary-700)',
    },
  },

  checkbox: {
    marginBottom: '8px',
  },
};
